import { render, staticRenderFns } from "./ChatDetailText.vue?vue&type=template&id=6bc3f9b6&scoped=true&"
import script from "./ChatDetailText.vue?vue&type=script&lang=js&"
export * from "./ChatDetailText.vue?vue&type=script&lang=js&"
import style0 from "./ChatDetailText.vue?vue&type=style&index=0&id=6bc3f9b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc3f9b6",
  null
  
)

export default component.exports